import { render } from "./FirstTimeButton.vue?vue&type=template&id=ce28d23e&scoped=true"
import script from "./FirstTimeButton.vue?vue&type=script&lang=js"
export * from "./FirstTimeButton.vue?vue&type=script&lang=js"

import "./FirstTimeButton.vue?vue&type=style&index=0&id=ce28d23e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce28d23e"]])

export default __exports__